import { render, staticRenderFns } from "./AddByDuxiangku.vue?vue&type=template&id=13c26798&scoped=true&"
import script from "./AddByDuxiangku.vue?vue&type=script&lang=js&"
export * from "./AddByDuxiangku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c26798",
  null
  
)

component.options.__file = "AddByDuxiangku.vue"
export default component.exports